import { createAsyncThunk } from '@reduxjs/toolkit';

import type { TCreditFormState } from 'entities/creditForm';
import { formReadyForSendingSelector, selectStepsFields, defaultStepperConfigSelector } from 'entities/creditForm';
import type { TUserState } from 'entities/user/model/user.selectors';
import { accountSelector } from 'entities/user/model/user.selectors';

import { sendCustomerDataThunk } from 'features/SendCustomerData';

import { recalculateSteps } from './stepper';

export const updateUserDataThunk = createAsyncThunk<void, void, { state: TCreditFormState & TUserState }>(
  'updateUserData/updateUserDataThunk',
  async (_, { dispatch, getState }) => {
    const user = accountSelector(getState());

    if (!user) {
      return;
    }

    const {
      activeStep,
      stepsWithMultiStepsOrder: steps,
      lastStep,
    } = recalculateSteps(defaultStepperConfigSelector(getState()));
    const isReady = formReadyForSendingSelector(getState());

    const filledSteps = steps
      .slice(0, isReady ? lastStep.stepIndex : (activeStep?.stepIndex ?? 2) - 1)
      .map((step) => step.formId);

    dispatch(sendCustomerDataThunk(selectStepsFields(filledSteps)(getState())));
  },
);
